export const DEFAULT_FETCH_HEADERS = {
  'accept': 'application/json',
  'content-type': 'application/json'
}

export const ERROR_MESSAGES = {
  start:
    'Der Antragsprozess kann derzeit nicht gestartet werden. Bitte versuchen Sie es später erneut. <br/><br/>Falls das Problem weiterhin besteht, kontaktieren Sie bitte unseren Kundenservice unter: <a href="tel:+494087409757">040/87 409 757</a>.',
  step: 'Der Antragsprozess kann derzeit nicht fortgesetzt werden. Bitte versuchen Sie es später erneut. <br/><br/>Falls das Problem weiterhin besteht, kontaktieren Sie bitte unseren Kundenservice unter: <a href="tel:+494087409757">040/87 409 757</a>.',
  document:
    'Ihre Antragsdokumente können derzeit nicht erstellt werden. Bitte versuchen Sie es später erneut. <br/><br/>Falls das Problem weiterhin besteht, kontaktieren Sie bitte unseren Kundenservice unter: <a href="tel:+494087409757">040/87 409 757</a>.',
  product:
    'Die Produktauswahl kann derzeit nicht geladen werden. Bitte versuchen Sie es später erneut. <br/><br/>Falls das Problem weiterhin besteht, kontaktieren Sie bitte unseren Kundenservice unter: <a href="tel:+494087409757">040/87 409 757</a>.'
}

export const DEFAULT_DOCUMENT_USE_CASE = 'phm'
